import { createRouter, createWebHistory } from 'vue-router'
import Payment from '../views/payment/index.vue'
import PayCallback from '../views/paycallback/index.vue'
import Jumping from '../views/jumping/index.vue'
import NotFound from '../views/NotFound.vue'
// import AccumRecharge from '../views/act/accumRecharge/index.vue'
import Accum from '../views/act/accum/index.vue'
import CNY from '../views/act/cny/index.vue'
const routes = [
  {
    path: '/:locale',
    children: [
      {
        path: '',
        name: 'Payment',
        component: Payment
      },
      // {
      //   path: 'accumRecharge',
      //   name: 'AccumRecharge',
      //   component: AccumRecharge
      // },
      {
        path: 'accum',
        name: 'Accum',
        component: Accum
      },
      {
        path: 'cny',
        name: 'CNY',
        component: CNY
      },
      {
        path: 'callback/:channel', // channel对应的是每个支付平台
        name: 'callback',
        component: PayCallback
      },
      {
        path: 'jumping',
        name: 'Jumping',
        component: Jumping
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  }
]
console.log(process.env.VUE_APP_HISTORY_URL, 'process.env.VUE_APP_HISTORY_URL')
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_HISTORY_URL),
  routes
})

export default router
